import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  {
    resource,
    calendarHolidays,
  }: Boundaries["assignCalendarHolidaysToResource"]["request"],
): State {
  const index = state.findIndex((res) => res.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { resource, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { resource, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  {
    resource,
    calendarHolidays,
  }: Boundaries["assignCalendarHolidaysToResource"]["success"],
): State {
  return state.map((res) =>
    res.resource.uuid === resource.uuid
      ? { resource, calendarHolidays, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  { resource }: Boundaries["assignCalendarHolidaysToResource"]["failure"],
): State {
  return state.map((res) =>
    res.resource.uuid === resource.uuid
      ? { resource, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.assignCalendarHolidaysToResourceRequested]: handleRequest,
    [events.assignCalendarHolidaysToResourceSucceeded]: handleSuccess,
    [events.assignCalendarHolidaysToResourceFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
